

class MeasureThings {
    constructor() {
    }
    start() {
        this.msdh = new map3d.Function.MeasureSpaceDistanceHeight();
        this.msdh.start()
    }
    startArea() {
        if (this.ma) {
            this.ma.end()
        }
        this.ma = new map3d.Function.MeasureArea({ url: require("../../static/img/billboard.png"), clampToGround: true });
        this.ma.start()
    }
}
export default new MeasureThings()




// WEBPACK FOOTER //
// ./src/mapfunction/MeasureThings.js